/**
 * @generated SignedSource<<da1aac60b01e973de6cc3b83411b4464>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileLinksBlock_itemSearch" | "SharedRespLinksBlock_itemSearch">;
  readonly " $fragmentType": "BuySharedMoreWaysToBrowse_itemSearch";
};
export type BuySharedMoreWaysToBrowse_itemSearch$key = {
  readonly " $data"?: BuySharedMoreWaysToBrowse_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedMoreWaysToBrowse_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedMoreWaysToBrowse_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "7b0e5d30ce527ab632ae3952942fa8f7";

export default node;
